exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-6c8361fe]::-webkit-inner-spin-button,input[data-v-6c8361fe]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-6c8361fe]{-moz-appearance:textfield}.tanpawrap[data-v-6c8361fe]{white-space:nowrap}", ""]);

// exports
